import React from 'react';
import { Phone, CheckCircle, Wrench, Truck } from 'lucide-react';
export function MotorHomeRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6785">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6786">
        <div className="container mx-auto px-4" data-id="element-6787">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6788">
            Motor Home Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6789">
            Specialized Maintenance, Repair and Inspection Services
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6790">
        <div className="max-w-6xl mx-auto" data-id="element-6791">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6792">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-6793">
              <div data-id="element-6794">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010024.JPG400x400.jpg?opt=w3" alt="Motor home service" className="rounded-lg shadow-md w-full h-auto" data-id="element-6795" />
              </div>
              <div data-id="element-6796">
                <p className="text-lg text-gray-700" data-id="element-6797">
                  <strong data-id="element-6798">Garrett Auto & Truck specializes</strong> in{' '}
                  <em data-id="element-6799">
                    <strong data-id="element-6800">maintenance</strong>
                  </em>
                  , repair and inspection of motor homes, motor coaches, and
                  medium/heavy-duty trucks. We service motor homes, as well as
                  motor coaches operated by tour and charter businesses,
                  churches, or other organizations.
                </p>
              </div>
            </div>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6801">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-6802">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-6803" />
              Complete Motor Home Services
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-6804">
              {/* Services List */}
              <div className="space-y-4" data-id="element-6805">
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-6806">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6807">
                    Oil Changes & Lubrication
                  </h3>
                  <p className="text-gray-700" data-id="element-6808">
                    Complete oil change and lubrication services
                  </p>
                </div>

                <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-6809">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6810">
                    Diesel & Gasoline Engines
                  </h3>
                  <p className="text-gray-700" data-id="element-6811">
                    Expert engine diagnostics and repair
                  </p>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-6812">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6813">
                    Transmissions & Drive train
                  </h3>
                  <p className="text-gray-700" data-id="element-6814">
                    Transmission service and drivetrain repair
                  </p>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-6815">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6816">
                    Major & Minor Mechanical Repairs
                  </h3>
                  <p className="text-gray-700" data-id="element-6817">
                    All mechanical repairs, large and small
                  </p>
                </div>

                <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-6818">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6819">
                    Air & Hydraulic Brake Systems
                  </h3>
                  <p className="text-gray-700" data-id="element-6820">
                    Complete brake system service and repair
                  </p>
                </div>

                <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4" data-id="element-6821">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6822">
                    Suspension Systems
                  </h3>
                  <p className="text-gray-700" data-id="element-6823">
                    Air, leaf, Coil, Torsion suspension repair
                  </p>
                </div>
              </div>

              {/* Image */}
              <div className="flex items-center justify-center" data-id="element-6824">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Picture3.gif400x400.jpg?opt=w3" alt="Motor home repair" className="rounded-lg shadow-md w-full h-auto" data-id="element-6825" />
              </div>
            </div>

            {/* Additional Services */}
            <div className="grid md:grid-cols-2 gap-4 mt-8" data-id="element-6826">
              <div className="bg-teal-50 border-l-4 border-teal-500 p-4" data-id="element-6827">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6828">
                  Electrical AC & DC
                </h3>
                <p className="text-gray-700" data-id="element-6829">
                  Complete electrical system diagnostics and repair
                </p>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-500 p-4" data-id="element-6830">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6831">
                  Generators
                </h3>
                <p className="text-gray-700" data-id="element-6832">
                  Generator service, repair, and maintenance
                </p>
              </div>

              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-4" data-id="element-6833">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6834">
                  Air conditioning
                </h3>
                <p className="text-gray-700" data-id="element-6835">AC system repair and recharge</p>
              </div>

              <div className="bg-pink-50 border-l-4 border-pink-500 p-4" data-id="element-6836">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6837">
                  Interior Repairs
                </h3>
                <p className="text-gray-700" data-id="element-6838">
                  Interior maintenance and repair services
                </p>
              </div>
            </div>
          </div>

          {/* Road Service */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-6839">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-6840">
              <div className="flex justify-center" data-id="element-6841">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Picture1.gif" alt="Road service truck" className="rounded-lg shadow-md" data-id="element-6842" />
              </div>
              <div data-id="element-6843">
                <h2 className="text-4xl font-bold mb-6 flex items-center" data-id="element-6844">
                  <Truck className="mr-3" size={40} data-id="element-6845" />
                  Road Service
                </h2>
                <p className="text-xl mb-4" data-id="element-6846">
                  <strong data-id="element-6847">
                    We have a service truck to go get your vehicle going if you
                    are broken down. If the problem is too severe to resolve on
                    site, we can just tow it ourself.
                  </strong>
                </p>
                <div className="bg-white/10 rounded-lg p-4" data-id="element-6848">
                  <p className="text-lg" data-id="element-6849">
                    Emergency roadside assistance and towing services available
                    for motor homes and motor coaches.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Service Categories Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6850">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6851">
              Who We Service
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-6852">
              <div className="text-center" data-id="element-6853">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6854">
                  <CheckCircle className="text-blue-600" size={32} data-id="element-6855" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6856">
                  Motor Homes
                </h3>
                <p className="text-gray-700" data-id="element-6857">
                  Personal and recreational motor homes of all sizes
                </p>
              </div>

              <div className="text-center" data-id="element-6858">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6859">
                  <CheckCircle className="text-green-600" size={32} data-id="element-6860" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6861">
                  Motor Coaches
                </h3>
                <p className="text-gray-700" data-id="element-6862">
                  Tour and charter business motor coaches
                </p>
              </div>

              <div className="text-center" data-id="element-6863">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-6864">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-6865" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6866">
                  Organizations
                </h3>
                <p className="text-gray-700" data-id="element-6867">
                  Church and organizational motor coaches
                </p>
              </div>
            </div>
          </div>

          {/* Services Checklist */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6868">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-6869">
              Complete Service Checklist
            </h2>

            <div className="grid md:grid-cols-2 gap-3" data-id="element-6870">
              <div className="flex items-start" data-id="element-6871">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6872" />
                <span className="text-gray-700" data-id="element-6873">Oil Changes & Lubrication</span>
              </div>
              <div className="flex items-start" data-id="element-6874">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6875" />
                <span className="text-gray-700" data-id="element-6876">
                  Diesel & Gasoline Engine Repair
                </span>
              </div>
              <div className="flex items-start" data-id="element-6877">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6878" />
                <span className="text-gray-700" data-id="element-6879">Transmission Service</span>
              </div>
              <div className="flex items-start" data-id="element-6880">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6881" />
                <span className="text-gray-700" data-id="element-6882">Drive Train Repair</span>
              </div>
              <div className="flex items-start" data-id="element-6883">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6884" />
                <span className="text-gray-700" data-id="element-6885">Major Mechanical Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-6886">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6887" />
                <span className="text-gray-700" data-id="element-6888">Minor Mechanical Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-6889">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6890" />
                <span className="text-gray-700" data-id="element-6891">Air Brake Systems</span>
              </div>
              <div className="flex items-start" data-id="element-6892">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6893" />
                <span className="text-gray-700" data-id="element-6894">Hydraulic Brake Systems</span>
              </div>
              <div className="flex items-start" data-id="element-6895">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6896" />
                <span className="text-gray-700" data-id="element-6897">Air Suspension</span>
              </div>
              <div className="flex items-start" data-id="element-6898">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6899" />
                <span className="text-gray-700" data-id="element-6900">
                  Leaf, Coil, Torsion Suspension
                </span>
              </div>
              <div className="flex items-start" data-id="element-6901">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6902" />
                <span className="text-gray-700" data-id="element-6903">Electrical AC Systems</span>
              </div>
              <div className="flex items-start" data-id="element-6904">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6905" />
                <span className="text-gray-700" data-id="element-6906">Electrical DC Systems</span>
              </div>
              <div className="flex items-start" data-id="element-6907">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6908" />
                <span className="text-gray-700" data-id="element-6909">
                  Generator Service & Repair
                </span>
              </div>
              <div className="flex items-start" data-id="element-6910">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6911" />
                <span className="text-gray-700" data-id="element-6912">Air Conditioning Service</span>
              </div>
              <div className="flex items-start" data-id="element-6913">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6914" />
                <span className="text-gray-700" data-id="element-6915">Interior Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-6916">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6917" />
                <span className="text-gray-700" data-id="element-6918">Road Service & Towing</span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6919">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6920">
              Expert Motor Home & Motor Coach Service
            </h2>
            <p className="text-xl mb-6" data-id="element-6921">
              Specialized maintenance, repair, and road service for all motor
              homes
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6922">
              <Phone className="mr-3" size={24} data-id="element-6923" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6924">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}